// extracted by mini-css-extract-plugin
export default {"commentWrapper":"styles_commentWrapper__WV1pP","replies":"styles_replies__mV61T"};